import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { AgreementFormData, AgreementFormDataService } from '../createEditAgreement/agreement-form-data';
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface OnInit {
  ngOnInit(): void
}

@Component({
    selector: 'agreementPreview',
    templateUrl: './agreementPreview.html',
    styleUrls: ['../createEditAgreement/createEditAgreement.css'],
    standalone: false
})
export class AgreementPreview implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private agreementDataService: AgreementFormDataService) {
  }

  add: boolean | null = null;
  id: number | null = null;
  openExitDialog = false
  faTriangleExclamation = faTriangleExclamation
  previewData!: AgreementFormData;
  breadcrumbNav: BreadcrumbNavigation[] = [{
    text: 'User Agreement Management',
    route: 'dashboard/AgreementManagement/list'
  }, {
    text: '',
    route: ''
  }]

  ngOnInit() {
    const token = document.cookie.split("; ").find((row) => row.startsWith("token="))?.split("=")[1];

    this.route.queryParams.subscribe(params => {
      this.id = params['id']
      this.add = params['add'] === 'true'
      if(this.add)
        this.breadcrumbNav[1].text = 'Add User Agreement'
      else {
        this.breadcrumbNav[1].text = 'Edit User Agreement'
        this.breadcrumbNav[1].queryParams = {queryParams: {id: this.id}}
      }
    })

    this.agreementDataService.formData$.subscribe(data => {
      if (data) {
        this.previewData = data;
      }
    });
  }

  agreementManagement() {
    this.router.navigate(['dashboard/AgreementManagement/list']);
  }

  agreementCreateEdit() {
    // TODO need to check if it was add or edit
    if(this.add)
      this.router.navigate(['dashboard/AgreementManagement/add']);
    else
      this.router.navigate(['dashboard/AgreementManagement/edit'], {queryParams: {id: this.id}});
  }

  closeExitDialog() {
    this.openExitDialog = false
  }
  showExitDialog() {
    this.openExitDialog = true
  }
}
